import React from 'react';
import NavbarComponent from '../pages/Navbar'; // ✅ same navbar
import Footer from '../Footer';               // ✅ same footer
import VideoNavBanner from './VideoNavBanner';
import GalleryNavSection from './GalleryNavSection';
const VideoNav = () => {
  return (
    <>
      <NavbarComponent />
     <VideoNavBanner/>
     <GalleryNavSection/>
      <Footer />
    </>
  );
};

export default VideoNav;
